import React from "react";

/**
 * Inline logo image used everywhere across the app. The asset ships with the
 * frontend bundle (no external dependency at runtime) so it works offline,
 * on custom domains, and isn't subject to a third-party host's availability.
 */
const LOGO_URL = "/logo.png";

/**
 * Brand: renders the Cybersecurity Forefront logo. The PNG already contains
 * the wordmark, so we expose it as a self-contained mark by default.
 *
 * Props:
 *   size  - 'sm' | 'md' | 'lg' (default 'md')
 *   className - extra utility classes
 */
export const Brand = ({ size = "md", className = "" }) => {
    const heightClass =
        size === "sm" ? "h-7" : size === "lg" ? "h-12" : "h-9";
    return (
        <a
            href="/"
            aria-label="Cybersecurity Forefront — home"
            className={`inline-flex items-center gap-3 group ${className}`}
            data-testid="brand-mark"
        >
            <img
                src={LOGO_URL}
                alt="Cybersecurity Forefront"
                className={`${heightClass} w-auto select-none transition-opacity duration-200 group-hover:opacity-90`}
                draggable={false}
            />
        </a>
    );
};

export default Brand;
